const text = (value) => typeof value === "string" ? value.trim() : "";

/** Resolve a deployment-neutral authenticated portal introduction. */
export function resolvePortalHeader(branding, { receptionistOnly = false } = {}) {
  const deployment = branding?.deployment || {};
  const platformName = text(branding?.platform?.name) || "HACaMS";
  return {
    eyebrow: `${platformName} / ${receptionistOnly ? "RECEPTION" : "SPACE OPERATIONS"}`,
    title: text(deployment.name) || "Your Space",
    subtitle: text(deployment.descriptor)
      || text(deployment.tagline)
      || "A connected space, ready for what comes next.",
  };
}
